module.exports = __webpack_public_path__ + "static/6305-woodrose-15-21d0ee34cbea5b81eaa0dd8c6dcaa886.jpg";